export const alert = (node, options) => {
    // return a new subscriber
    return {
        start: () => { },
        next: (value) => {
            let msg = options.message;
            // received a value as message?
            if (typeof value === "string") {
                msg = value;
            }
            if (msg !== undefined) {
                window.alert(msg);
            }
            else {
                console.warn("Alert-Plugin: Message Option not defined and the received value is not from type string. => Nothing to show");
            }
        },
        error: () => { },
        complete: () => { }
    };
};
//# sourceMappingURL=alert.js.map